import graphqlClient from "../../../apollo";

class CuentaProveedorProvider {
  cuentaProveedorDeuda(proveedorId) {
    return graphqlClient.query({
      query: require("./gql/cuentaProveedorDeuda.graphql"),
      variables: { proveedorId },
      fetchPolicy: "network-only",
    });
  }

  cuentaProveedorMovimientos(proveedorId, pageNumber = 1, itemsPerPage = 20) {
    return graphqlClient.query({
      query: require("./gql/cuentaProveedorMovimientos.graphql"),
      variables: { proveedorId, pageNumber, itemsPerPage },
      fetchPolicy: "network-only",
    });
  }
}

export default new CuentaProveedorProvider();
